import React, { Component } from 'react';
import { Layers, Shield, Ruler, Wrench, Hammer, ClipboardList, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    num: 'M1',
    icon: Layers,
    title: 'Perfiles y Fundamentos',
    desc: 'Componentes, sistemas y refuerzos de acero con lenguaje de taller.'
  }, {
    num: 'M2',
    icon: Shield,
    title: 'El Universo del DVH',
    desc: 'Float, Low-E, composiciones por zona climática y cómo pedirlo sin error.'
  }, {
    num: 'M3',
    icon: Ruler,
    title: 'Fórmulas y Tablas de Corte',
    desc: 'Fórmulas exactas para cada tipología. Sin calcular de cabeza nunca más.'
  }, {
    num: 'M4',
    icon: Wrench,
    title: 'Herrajes y Mecanizados',
    desc: 'Selección, posición exacta al milímetro y tablas de mecanizado por sistema.'
  }, {
    num: 'M5',
    icon: Hammer,
    title: 'Fabricación y Termofusión',
    desc: 'El proceso completo con temperaturas, tiempos y protocolo de 12 etapas.'
  }, {
    num: 'M6',
    icon: ClipboardList,
    title: 'Instalación y Sellado',
    desc: 'Calzado, fijación, sellado en 4 capas y entrega documentada con firma.'
  }];
  const includes = ['Fórmulas listas para imprimir', 'Protocolos paso a paso', 'Checklists de verificación', 'Planillas A4 para el taller'];
  return <section className="py-20 md:py-24 relative border-y border-white/5" data-id="element-189">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true" style={{
      background: 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(212, 168, 67, 0.06) 0%, transparent 70%)'
    }} data-id="element-190" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-191">
        <FadeIn data-id="element-192">
          <div className="text-center mb-14 max-w-3xl mx-auto" data-id="element-193">
            <div className="section-eyebrow mb-5" data-id="element-194">
              <span data-id="element-195">El sistema completo</span>
            </div>
            <h2 className="font-heading font-extrabold heading-tight text-white text-3xl md:text-5xl mb-5" data-id="element-196">
              6 Módulos.{' '}
              <span className="gold-gradient-text" data-id="element-197">Todo resuelto.</span>
            </h2>
            <p className="text-lg text-gold mb-3" data-id="element-198">
              Corredizo → Batiente → Oscilobatiente → Paño Fijo → Puerta Balcón
            </p>
            <p className="text-gray-400 text-base md:text-lg" data-id="element-199">
              240+ páginas de fórmulas, checklists y protocolos.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-16 max-w-6xl mx-auto" data-id="element-200">
          {modules.map((mod, i) => {
          const Icon = mod.icon;
          return <FadeIn key={i} delay={i * 0.05} data-id="element-201">
                <div className="bg-surface/60 backdrop-blur p-7 rounded-2xl border border-white/10 hover:border-gold/40 hover:bg-surface transition-all duration-300 group h-full relative overflow-hidden" data-id="element-202">
                  <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" aria-hidden="true" style={{
                background: 'radial-gradient(circle, rgba(212, 168, 67, 0.18) 0%, transparent 70%)'
              }} data-id="element-203" />
                  <div className="relative z-10" data-id="element-204">
                    <div className="flex items-center justify-between mb-5" data-id="element-205">
                      <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center group-hover:scale-110 group-hover:bg-gold/15 transition-all" data-id="element-206">
                        <Icon className="w-6 h-6 text-gold" data-id="element-207" />
                      </div>
                      <span className="text-xs font-bold text-gold/60 tracking-widest" data-id="element-208">
                        {mod.num}
                      </span>
                    </div>
                    <h3 className="text-lg md:text-xl font-heading font-bold mb-2 text-white leading-tight" data-id="element-209">
                      {mod.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-210">
                      {mod.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.5} data-id="element-211">
          <div className="bg-surface/40 backdrop-blur p-8 rounded-2xl border border-gold/20 max-w-4xl mx-auto" data-id="element-212">
            <h4 className="text-center text-sm uppercase tracking-widest text-gold mb-6 font-semibold" data-id="element-213">
              Cada módulo incluye
            </h4>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-214">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-216" />
                  <span className="text-gray-200 text-sm" data-id="element-217">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}